import React from 'react';
import { Section } from 'components/common/override-rates/Section';
import { SectionHeader } from 'components/common/override-rates/SectionHeader';
import { DiscountPanel } from 'components/common/override-rates/DiscountPanel';
import { EditProductRatesForm } from 'components/common/override-rates/EditProductRatesForm';
import { RatesConfigurationZone } from 'components/common/override-rates/RatesConfigurationZone';
import { observer } from 'mobx-react-lite';
import { useOverrideUwRatesPageStore } from 'store/pages/override-uw-rates/pageStore';
import { ChooseQuotesBar } from '../ChooseQuotesBar';

export const OverrideRatesSection: React.FC = observer(() => {
  const {
    uwRatesOverriderDelegate: { rateForms, selectedRateSource, discountForm, restoreInitialRates },
  } = useOverrideUwRatesPageStore();

  return (
    <Section>
      <SectionHeader title="Override Rates" actionSection={<ChooseQuotesBar />} />
      <DiscountPanel
        originalRatesName={selectedRateSource === 'original' ? 'Quoted' : 'Final'}
        restoreRates={restoreInitialRates}
        formController={discountForm}
      />
      <RatesConfigurationZone>
        {rateForms.map((form) => (
          <EditProductRatesForm
            key={form.productName}
            productName={form.productName}
            rates={form.ratesBySelectedSource}
            formController={form.formController}
          />
        ))}
      </RatesConfigurationZone>
    </Section>
  );
});
